/**
 * Application entry point
 */

// Load application styles
import 'scss/_index.scss';

// ================================
// START YOUR APP HERE
// ================================
(() => {

  const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1
    || window.safari;

  if (isSafari) {
    const parallaxTrigger = Array.from(document.querySelectorAll('.parallax'));
    parallaxTrigger.forEach(trigger => {
      console.log('PARALLAX', trigger);
      trigger.classList.remove('parallax');
    });

    const vidframes = Array.from(document.querySelectorAll('[data-jarallax-video]'));
    vidframes.forEach(vid => {
      vid.removeAttribute('data-jarallax-video');
      vid.classList.add('fallback-bg');
      const overlay = vid.querySelector('.overlay_background');
      overlay.parentElement.removeChild(overlay);
    });
  }

  // patch speakers headline
  const speakersHeadline = document.querySelector('.ppb_session_filterable + .one .ppb_title');
  if (speakersHeadline) {
    speakersHeadline.id = 'speaker';
  }

  // document.addEventListener('DOMContentLoaded', () => {
    const headlines = Array.from(document.querySelectorAll('.scheduleday_title_content'));

    headlines.forEach(headline => {
      if (/[0-9]+\./.test(headline.firstChild.textContent)) {
        headline.firstChild.innerHTML = headline.firstChild.textContent.substring(3);
      }
    });
  // });
  

  const teasers = Array.from(document.querySelectorAll('.teaser_content_wrapper'));
  teasers.forEach(teaser => {
    teaser = teaser.closest('.teaser_wrapper');
    teaser.classList.add('clickable-teaser');
    teaser.addEventListener('click', (event) => {
      const el = teaser.querySelector('[data-href]');
      if (el) {
        location.href = el.dataset.href;
      }
    })
  });

})();